module.exports = __webpack_public_path__ + "img/iliosTask.96373633.svg";